import React, { useEffect, useMemo, useState } from "react";
import { db } from "./firebase";
import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  onSnapshot,
  updateDoc,
  getDocs,
  writeBatch,
} from "firebase/firestore";
import { getAuth, signInAnonymously } from "firebase/auth";
import bg from "./mcd.png";
import * as XLSX from "xlsx";



export default function AdminPage() {
  const [authReady, setAuthReady] = useState(false);
  // ===============================
  // LOGIN
  // ===============================
  const [logged, setLogged] = useState(
    localStorage.getItem("uniformes:logged") === "true"
  );
  const [userInput, setUserInput] = useState("");
  const [passInput, setPassInput] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    if (userInput.trim().toLowerCase() === "mcd" && passInput === "1351") {
      localStorage.setItem("uniformes:logged", "true");
      setLogged(true);
    } else {
      alert("Usuario o contraseña incorrectos");
    }
  };

  // ===============================
  // INVENTARIO
  // ===============================
  const [items, setItems] = useState([]);

  // FORMULARIO
  const [tipo, setTipo] = useState("Pantalón");
  const [sexo, setSexo] = useState("Hombre");
  const [rol, setRol] = useState("Crew");
  const [talla, setTalla] = useState("32");
  const [cantidad, setCantidad] = useState(0);
  const [notas, setNotas] = useState("");

  const [entrenador, setEntrenador] = useState(false);
  const [premama, setPremama] = useState(false);

  const [editingId, setEditingId] = useState(null);

  // ===============================
  // INFORME MANUAL (periodo)
  // ===============================
  const [reportFrom, setReportFrom] = useState(""); // yyyy-mm-dd
  const [reportTo, setReportTo] = useState(""); // yyyy-mm-dd

  // FILTROS TABLA
  const [filterTipo, setFilterTipo] = useState("");
  const [filterSexo, setFilterSexo] = useState("");
  const [filterRol, setFilterRol] = useState("");
  const [filterTalla, setFilterTalla] = useState("");

  // ORDEN TALLA (asc/desc)
  const [sortTalla, setSortTalla] = useState("asc");

  // ===============================
  // PETICIONES
  // ===============================
  const [requests, setRequests] = useState([]);
  const [faltantesReport, setFaltantesReport] = useState(null);
  const [acceptedRequests, setAcceptedRequests] = useState([]);
  // ===============================
  // REGLAS DE TALLAS
  // ===============================
  const CAMI_CHAQ_SIZES = [
    "2XS",
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "2XL",
    "3XL",
    "4XL",
    "5XL",
  ];
  const PANT_SIZES = Array.from(
    { length: (72 - 32) / 2 + 1 },
    (_, i) => 32 + i * 2
  );
  const BELT_SIZES = ["L", "XL", "2XL"];
  const CALZAS_SIZES = ["S", "M", "L", "XL"];

  const ACCESSORY_TYPES = [
    "Gorra",
    "Bandana",
    "Pañuelo",
    "Delantal corto",
    "Delantal largo",
  ];

  const FORCE_UNISEX_TYPES = [...ACCESSORY_TYPES, "Cinturón", "Calzas"];

  const ROLE_LOCK_TYPES = [
    ...ACCESSORY_TYPES,
    "Cinturón",
    "Chaqueta",
    "Calzas",
    "Americana",
    "Chaleco",
  ];

  const FORCE_ROLE_BY_TYPE = {
    Americana: "PEC",
    Chaleco: "Encargado",
    Calzas: "Todos",
    Gorra: "Todos",
    Bandana: "Todos",
    Pañuelo: "Todos",
    "Delantal corto": "Todos",
    "Delantal largo": "Todos",
    Cinturón: "Todos",
    Chaqueta: "Todos",
  };

  const getSizeOptionsByType = (t) => {
    if (t === "Camiseta" || t === "Chaqueta") return CAMI_CHAQ_SIZES;
    if (t === "Americana") return CAMI_CHAQ_SIZES;
    if (t === "Chaleco") return CAMI_CHAQ_SIZES;
    if (t === "Pantalón") return PANT_SIZES;
    if (t === "Cinturón") return BELT_SIZES;
    if (t === "Calzas") return CALZAS_SIZES;
    return [];
  };

  // ===============================
  // FIRESTORE INVENTARIO
  // ===============================
  useEffect(() => {
  let unsub;
  (async () => {
    if (!logged) return;

    const auth = getAuth();
    try {
      await signInAnonymously(auth);
      setAuthReady(true);
    } catch (e) {
      console.error("Auth error:", e);
      setAuthReady(false);
      return;
    }

    unsub = onSnapshot(collection(db, "items"), (snap) => {
      setItems(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
  })();

  return () => unsub && unsub();
}, [logged]);


  // ===============================
  // FIRESTORE PETICIONES (requests)
  // ===============================
  useEffect(() => {
    if (!logged) return;
    const unsub = onSnapshot(collection(db, "requests"), (snap) => {
      setRequests(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, [logged]);
useEffect(() => {
  if (!logged) return;
  const unsub = onSnapshot(collection(db, "acceptedRequests"), (snap) => {
    setAcceptedRequests(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
  return () => unsub();
}, [logged]);
  // ===============================
  // OPCIONES DISPONIBLES PARA FILTROS
  // ===============================
  const baseForFilterOptions = useMemo(() => {
    let base = items;
    if (filterTipo) base = base.filter((it) => it.tipo === filterTipo);
    return base;
  }, [items, filterTipo]);

  const filterSexoOptions = useMemo(
    () => [...new Set(baseForFilterOptions.map((it) => it.sexo))],
    [baseForFilterOptions]
  );
  const filterRolOptions = useMemo(
    () => [...new Set(baseForFilterOptions.map((it) => it.rol))],
    [baseForFilterOptions]
  );
  const filterTallaOptions = useMemo(
    () => [...new Set(baseForFilterOptions.map((it) => it.talla))],
    [baseForFilterOptions]
  );

  // ===============================
  // ORDEN TALLAS
  // ===============================
  const sizeRank = (s) => {
    const n = Number(s);
    if (!Number.isNaN(n)) return 1000 + n;

    const beltOrder = { L: 2000, XL: 2001, "2XL": 2002 };
    if (beltOrder[s] != null) return beltOrder[s];

    const shirtOrder = {
      "2XS": 10,
      XS: 11,
      S: 12,
      M: 13,
      L: 14,
      XL: 15,
      "2XL": 16,
      "3XL": 17,
      "4XL": 18,
      "5XL": 19,
    };
    if (shirtOrder[s] != null) return 3000 + shirtOrder[s];

    const calzasOrder = { S: 1, M: 2, L: 3, XL: 4 };
    if (calzasOrder[s] != null) return 4000 + calzasOrder[s];

    if (s === "Única") return 5000;

    return 9000 + s.charCodeAt(0);
  };

  // ===============================
  // FILTRO + ORDEN
  // ===============================
  const filtered = useMemo(() => {
    const f = items.filter((it) => {
      if (filterTipo && it.tipo !== filterTipo) return false;
      if (filterSexo && it.sexo !== filterSexo) return false;
      if (filterRol && it.rol !== filterRol) return false;
      if (filterTalla && it.talla !== filterTalla) return false;
      return true;
    });

    const sorted = [...f].sort((a, b) => sizeRank(a.talla) - sizeRank(b.talla));
    if (sortTalla === "desc") sorted.reverse();
    return sorted;
  }, [items, filterTipo, filterSexo, filterRol, filterTalla, sortTalla]);

  // ===============================
  // AÑADIR / EDITAR
  // ===============================
  const handleAdd = async () => {
    const c = Number(cantidad) || 0;
    const entrenadorValido = tipo === "Camiseta" && rol === "Crew";
    const premamaValida = tipo === "Pantalón" && sexo === "Mujer";

    if (editingId) {
      const existing = items.find((x) => x.id === editingId);
      if (!existing) return setEditingId(null);

      if (c === 0) {
        const ok = window.confirm(
          "La cantidad es 0. ¿Quieres eliminar este uniforme del inventario?"
        );
        if (ok) await deleteDoc(doc(db, "items", editingId));
        setEditingId(null);
        setCantidad(0);
        setNotas("");
        setEntrenador(false);
        setPremama(false);
        return;
      }

      await updateDoc(doc(db, "items", editingId), {
        tipo,
        sexo,
        rol,
        talla,
        cantidad: c,
        notas,
        entrenador: entrenadorValido ? entrenador : false,
        premama: premamaValida ? premama : false,
      });

      setEditingId(null);
      setCantidad(0);
      setNotas("");
      setEntrenador(false);
      setPremama(false);
      return;
    }

    const dup = items.find((it) => {
      const sameBase =
        it.tipo === tipo &&
        it.sexo === sexo &&
        it.rol === rol &&
        it.talla === talla;
      if (!sameBase) return false;
      if (tipo === "Camiseta" && rol === "Crew") {
        return Boolean(it.entrenador) === Boolean(entrenador);
      }
      if (tipo === "Pantalón" && sexo === "Mujer") {
        return Boolean(it.premama) === Boolean(premama);
      }
      return true;
    });

    if (dup) {
      const nueva = (Number(dup.cantidad) || 0) + c;
      if (nueva <= 0) {
        const ok = window.confirm(
          "La cantidad quedará en 0. ¿Quieres eliminar este uniforme del inventario?"
        );
        if (ok) await deleteDoc(doc(db, "items", dup.id));
      } else {
        await updateDoc(doc(db, "items", dup.id), { cantidad: nueva });
      }
      setCantidad(0);
      setNotas("");
      setEntrenador(false);
      setPremama(false);
      return;
    }

    if (c <= 0)
      return alert("La cantidad debe ser mayor que 0 para un artículo nuevo.");

    await addDoc(collection(db, "items"), {
      tipo,
      sexo,
      rol,
      talla,
      cantidad: c,
      notas,
      entrenador: entrenadorValido ? entrenador : false,
      premama: premamaValida ? premama : false,
    });

    setCantidad(0);
    setNotas("");
    setEntrenador(false);
    setPremama(false);
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Seguro que quieres eliminar este uniforme?")) {
      await deleteDoc(doc(db, "items", id));
    }
  };

  const inc = async (id, delta) => {
    const it = items.find((x) => x.id === id);
    if (!it) return;
    const nueva = (Number(it.cantidad) || 0) + delta;
    if (nueva <= 0) {
      const ok = window.confirm(
        "La cantidad quedará en 0. ¿Quieres eliminar este uniforme del inventario?"
      );
      if (ok) await deleteDoc(doc(db, "items", id));
      return;
    }
    await updateDoc(doc(db, "items", id), { cantidad: nueva });
  };

  const editItem = (it) => {
    setEditingId(it.id);
    setTipo(it.tipo);
    setSexo(it.sexo);
    setRol(it.rol);
    setTalla(it.talla);
    setCantidad(it.cantidad);
    setNotas(it.notas || "");
    setEntrenador(Boolean(it.entrenador));
    setPremama(Boolean(it.premama));
  };

   // ===============================
  // Helper fechas (Timestamp/number/string)
  // ===============================
  const toJSDate = (v) => {
    if (!v) return null;
    if (v.toDate) return v.toDate(); // Firestore Timestamp
    if (typeof v === "number") return new Date(v);
    const d = new Date(v);
    return isNaN(d.getTime()) ? null : d;
  };

  // ===============================
  // INFORME MANUAL POR PERIODO (solo confirmadas)
  // ===============================
  const exportAcceptedReportByPeriod = () => {
  if (!reportFrom || !reportTo) {
    alert("Selecciona fecha desde y hasta.");
    return;
  }

  const fromMs = new Date(reportFrom + "T00:00:00").getTime();
  const toMs   = new Date(reportTo   + "T23:59:59").getTime();

  const accepted = acceptedRequests.filter((r) => {
    const d = toJSDate(r.acceptedAt || r.confirmedAt || r.createdAt);
    if (!d) return false;
    const ms = d.getTime();
    return ms >= fromMs && ms <= toMs;
  });

  if (accepted.length === 0) {
    alert("No hay peticiones aceptadas en ese periodo.");
    return;
  }

  const map = new Map();

  for (const r of accepted) {
    const empleado = (r.empleado || "—").trim();
    const restaurante = (r.restaurante || "—").trim();
    const key = `${empleado}__${restaurante}`;

    if (!map.has(key)) {
      map.set(key, {
        Empleado: empleado,
        Restaurante: restaurante,
        Uniformes: [],
      });
    }

    const itemTxt = [
      r.tipo,
      r.sexo,
      r.rol,
      r.talla,
      r.entrenador ? "(Entrenador)" : "",
      r.premama ? "(Premamá)" : "",
      `x${Number(r.cantidad) || 1}`,
    ]
      .filter(Boolean)
      .join(" ");

    map.get(key).Uniformes.push(itemTxt);
  }

  const rows = Array.from(map.values()).map((x) => ({
    Empleado: x.Empleado,
    Restaurante: x.Restaurante,
    "Uniformes pedidos": x.Uniformes.join(" | "),
    "Nº líneas": x.Uniformes.length,
  }));

  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Informe");

  const name = `informe_uniformes_${reportFrom}_a_${reportTo}.xlsx`;
  XLSX.writeFile(wb, name);
};

// ===============================
  // CONFIRMAR PETICIONES
  // ===============================
  const confirmRequests = async () => {
    if (!authReady) {
    alert("Espera un segundo a que se carguen permisos y vuelve a intentar.");
    return;
  }
    const pending = requests.filter((r) => !r.confirmed);
    if (pending.length === 0) {
      alert("No hay peticiones pendientes.");
      return;
    }

    if (!window.confirm("¿Confirmar todas las peticiones pendientes?")) return;

    const itemsSnap = await getDocs(collection(db, "items"));
    const currentItems = itemsSnap.docs.map((d) => ({ id: d.id, ...d.data() }));

    const faltantes = [];
    const batch = writeBatch(db);

    const findItemMatch = (req) => {
      return currentItems.find((it) => {
        const sameBase =
          it.tipo === req.tipo &&
          it.sexo === req.sexo &&
          it.rol === req.rol &&
          it.talla === req.talla;

        if (!sameBase) return false;

        if (req.tipo === "Camiseta" && req.rol === "Crew") {
          return Boolean(it.entrenador) === Boolean(req.entrenador);
        }

        // ✅ premamá correcto según la petición
        if (req.tipo === "Pantalón" && req.sexo === "Mujer") {
          return Boolean(it.premama) === Boolean(req.premama);
        }

        return true;
      });
    };

    for (const req of pending) {
      const match = findItemMatch(req);

      if (!match) {
        faltantes.push({
          ...req,
          falta: req.cantidad,
          motivo: "No existe en inventario",
        });
        continue;
        // ✅ Guardar histórico de aceptadas
  const acceptedRef = doc(collection(db, "acceptedRequests"));
  batch.set(acceptedRef, {
    ...req,
    acceptedAt: Date.now(),
    acceptedBy: "admin-batch",
  });

  // Marcar petición confirmada
  batch.update(doc(db, "requests", req.id), {
    confirmed: true,
    confirmedAt: Date.now(),
  });
      }

      const stock = Number(match.cantidad) || 0;
      const necesitados = Number(req.cantidad) || 0;

      if (stock >= necesitados) {
        const nuevaCantidad = stock - necesitados;

        if (nuevaCantidad <= 0) {
          batch.delete(doc(db, "items", match.id));
        } else {
          batch.update(doc(db, "items", match.id), { cantidad: nuevaCantidad });
        }
      } else {
        faltantes.push({
          ...req,
          falta: necesitados - stock,
          motivo: "Stock insuficiente",
        });

        if (stock > 0) {
          batch.delete(doc(db, "items", match.id));
        }
      }

      batch.update(doc(db, "requests", req.id), {
        confirmed: true,
        confirmedAt: Date.now(),
      });
    }

    await batch.commit();

    setFaltantesReport(faltantes);

    if (faltantes.length === 0) {
      alert("Peticiones confirmadas. Stock actualizado sin faltantes.");
    } else {
      alert(
        `Peticiones confirmadas con faltantes. Revisa el informe de faltantes (${faltantes.length}).`
      );
    }
  };

  // ===============================
  // RENDER — LOGIN
  // ===============================
  if (!logged) {
    return (
      <div
        className="min-h-screen flex items-center justify-center p-4"
        style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.94), rgba(255,255,255,0.96)), url(${bg})`,
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
        }}
      >
        <div className="w-full max-w-sm bg-white p-6 rounded-2xl shadow-xl">
          <h2 className="text-2xl font-extrabold text-[#0B4F3A] text-center">
            Acceso inventario
          </h2>
          <p className="text-sm text-gray-500 text-center mb-4">
            Introduce tus credenciales
          </p>

          <form onSubmit={handleLogin} className="space-y-3" autoComplete="off">
            <label className="block text-sm">
              Usuario
              <input
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                className="mt-1 w-full px-3 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FFC72C]"
                placeholder="Usuario"
                name="login_user"
                autoComplete="off"
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck={false}
              />
            </label>

            <label className="block text-sm">
              Contraseña
              <input
                type="password"
                value={passInput}
                onChange={(e) => setPassInput(e.target.value)}
                className="mt-1 w-full px-3 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FFC72C]"
                placeholder="Contraseña"
                name="login_pass"
                autoComplete="new-password"
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck={false}
              />
            </label>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-[#FFC72C] to-[#0B4F3A] text-white py-2 rounded-xl font-semibold shadow-md hover:opacity-95 transition"
            >
              Entrar
            </button>
          </form>
        </div>
      </div>
    );
  }

  // ===============================
  // RENDER — APLICACIÓN
  // ===============================
  return (
    <div
      className="min-h-screen text-slate-800"
      style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.94), rgba(255,255,255,0.96)), url(${bg})`,
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
      }}
    >
      {/* HEADER */}
      <header className="sticky top-0 z-10 border-b border-white/20 bg-white/60 backdrop-blur-md">
        <div className="max-w-6xl mx-auto p-4 flex flex-col gap-3 md:flex-row md:items-end md:gap-4 justify-between">
          <div>
            <h1 className="text-3xl font-extrabold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-[#FFC72C] to-[#0B4F3A]">
              Gestor de Stock de Uniformes
            </h1>
            <p className="text-sm text-slate-600">
              Controla pantalones, camisetas, chaquetas y accesorios.
            </p>
          </div>

          <button
            onClick={() => {
              localStorage.removeItem("uniformes:logged");
              setLogged(false);
              setEditingId(null);
            }}
            className="px-4 py-2 rounded-xl bg-gradient-to-r from-[#0B4F3A] to-[#FFC72C] text-white shadow hover:opacity-95 transition"
          >
            Cerrar sesión
          </button>
        </div>
      </header>

      {/* LAYOUT 1/3 – 2/3 */}
      <main className="max-w-6xl mx-auto p-6 grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* COLUMNA IZQUIERDA (FORM) */}
        <section className="md:col-span-1">
          <div className="bg-white rounded-2xl shadow p-6">
            <h2 className="text-xl font-semibold mb-4 text-[#0B4F3A]">
              {editingId ? "Editar registro" : "Añadir registro"}
            </h2>

            <div className="space-y-3">
              {/* TIPO */}
              <label className="block text-sm">
                Tipo
                <select
                  value={tipo}
                  onChange={(e) => {
                    const t = e.target.value;
                    setTipo(t);

                    if (!(t === "Camiseta" && rol === "Crew")) {
                      setEntrenador(false);
                    }
                    if (t !== "Pantalón" || sexo !== "Mujer") {
                      setPremama(false);
                    }

                    if (ACCESSORY_TYPES.includes(t)) {
                      setSexo("Unisex");
                      setTalla("Única");
                    } else if (t === "Cinturón") {
                      setSexo("Unisex");
                      setTalla(BELT_SIZES[0]);
                    } else if (
                      t === "Camiseta" ||
                      t === "Chaqueta" ||
                      t === "Americana" ||
                      t === "Chaleco"
                    ) {
                      setSexo("Hombre");
                      setTalla(CAMI_CHAQ_SIZES[0]);
                    } else if (t === "Pantalón") {
                      setSexo("Hombre");
                      setTalla(PANT_SIZES[0]);
                    } else if (t === "Calzas") {
                      setSexo("Unisex");
                      setTalla(CALZAS_SIZES[0]);
                    }

                    if (FORCE_ROLE_BY_TYPE[t]) {
                      setRol(FORCE_ROLE_BY_TYPE[t]);
                    } else if (ROLE_LOCK_TYPES.includes(t)) {
                      if (t === "Camiseta" || t === "Pantalón") {
                        setRol("Crew");
                      } else {
                        setRol("Todos");
                      }
                    }
                  }}
                  className="mt-1 w-full border px-3 py-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FFC72C]"
                >
                  <option>Pantalón</option>
                  <option>Camiseta</option>
                  <option>Chaqueta</option>
                  <option>Americana</option>
                  <option>Chaleco</option>
                  <option>Calzas</option>
                  <option>Gorra</option>
                  <option>Bandana</option>
                  <option>Pañuelo</option>
                  <option>Cinturón</option>
                  <option>Delantal corto</option>
                  <option>Delantal largo</option>
                </select>
              </label>

              {/* SEXO / ROL */}
              <div className="grid grid-cols-2 gap-3">
                <label className="block text-sm">
                  Sexo
                  <select
                    value={sexo}
                    onChange={(e) => {
                      const s = e.target.value;
                      setSexo(s);
                      if (!(tipo === "Pantalón" && s === "Mujer")) {
                        setPremama(false);
                      }
                    }}
                    disabled={FORCE_UNISEX_TYPES.includes(tipo)}
                    className="mt-1 w-full border px-3 py-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FFC72C]"
                  >
                    <option>Hombre</option>
                    <option>Mujer</option>
                    <option>Unisex</option>
                  </select>
                </label>

                <label className="block text-sm">
                  Rol
                  <select
                    value={rol}
                    onChange={(e) => {
                      const r = e.target.value;
                      setRol(r);
                      if (!(tipo === "Camiseta" && r === "Crew")) {
                        setEntrenador(false);
                      }
                    }}
                    disabled={ROLE_LOCK_TYPES.includes(tipo)}
                    className="mt-1 w-full border px-3 py-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FFC72C]"
                  >
                    <option>Crew</option>
                    <option>PEC</option>
                    <option>Encargado</option>
                    {!(tipo === "Camiseta" || tipo === "Pantalón") && (
                      <option>Todos</option>
                    )}
                  </select>
                </label>
              </div>

              {/* Checkbox Entrenador */}
              {tipo === "Camiseta" && rol === "Crew" && (
                <label className="flex items-center gap-2 text-sm">
                  <input
                    type="checkbox"
                    checked={entrenador}
                    onChange={(e) => setEntrenador(e.target.checked)}
                    className="h-4 w-4"
                  />
                  Camiseta de Entrenador
                </label>
              )}

              {/* Checkbox Premamá */}
              {tipo === "Pantalón" && sexo === "Mujer" && (
                <label className="flex items-center gap-2 text-sm">
                  <input
                    type="checkbox"
                    checked={premama}
                    onChange={(e) => setPremama(e.target.checked)}
                    className="h-4 w-4"
                  />
                  Pantalón Premamá
                </label>
              )}

              {/* TALLA / CANTIDAD */}
              <div className="grid grid-cols-2 gap-3">
                <label className="block text-sm">
                  Talla
                  <select
                    value={talla}
                    onChange={(e) => setTalla(e.target.value)}
                    disabled={ACCESSORY_TYPES.includes(tipo)}
                    className="mt-1 w-full border px-3 py-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FFC72C]"
                  >
                    {ACCESSORY_TYPES.includes(tipo) ? (
                      <option value="Única">Única</option>
                    ) : (
                      getSizeOptionsByType(tipo).map((s) => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))
                    )}
                  </select>
                </label>

                <label className="block text-sm">
                  Cantidad
                  <input
                    type="number"
                    value={cantidad}
                    onChange={(e) => setCantidad(e.target.value)}
                    className="mt-1 w-full border px-3 py-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FFC72C]"
                  />
                </label>
              </div>

              {/* NOTAS */}
              <label className="block text-sm">
                Notas
                <input
                  type="text"
                  value={notas}
                  onChange={(e) => setNotas(e.target.value)}
                  placeholder="Ej. almacén 2, caja 4"
                  className="mt-1 w-full border px-3 py-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FFC72C]"
                />
              </label>

              {/* BOTONES */}
              <div className="flex gap-3">
                <button
                  onClick={handleAdd}
                  className="flex-1 bg-gradient-to-r from-[#FFC72C] to-[#0B4F3A] text-white py-2 rounded-xl font-semibold hover:opacity-95 transition"
                >
                  {editingId ? "Guardar cambios" : "Añadir"}
                </button>
                {editingId && (
                  <button
                    onClick={() => {
                      setEditingId(null);
                      setCantidad(0);
                      setNotas("");
                      setEntrenador(false);
                      setPremama(false);
                    }}
                    className="px-4 py-2 rounded-xl border"
                  >
                    Cancelar
                  </button>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* COLUMNA DERECHA */}
        <section className="md:col-span-2">
          <div className="bg-white rounded-2xl shadow p-6">
            {/* ===== PETICIONES ===== */}
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4">
              <h3 className="text-lg font-semibold text-[#0B4F3A]">
                Peticiones pendientes:{" "}
                {requests.filter((r) => !r.confirmed).length}
              </h3>

              <div className="flex gap-2">
                <button
                  onClick={() => window.location.assign("/peticiones-admin")}
                  className="px-4 py-2 rounded-lg bg-[#FFC72C] text-black font-semibold shadow hover:brightness-95"
                >
                  Ver peticiones
                </button>
               
              </div>
            </div>

            {/* ===== INFORME MANUAL ===== */}
            <div className="mt-3 p-3 rounded-xl bg-slate-50 border flex flex-col md:flex-row gap-3 md:items-end">
              <div className="flex flex-col">
                <label className="text-sm font-medium">Desde</label>
                <input
                  type="date"
                  value={reportFrom}
                  onChange={(e) => setReportFrom(e.target.value)}
                  className="border px-3 py-2 rounded-lg"
                />
              </div>

              <div className="flex flex-col">
                <label className="text-sm font-medium">Hasta</label>
                <input
                  type="date"
                  value={reportTo}
                  onChange={(e) => setReportTo(e.target.value)}
                  className="border px-3 py-2 rounded-lg"
                />
              </div>

              <button
                onClick={exportAcceptedReportByPeriod}
                className="px-4 py-2 rounded-lg bg-[#0B4F3A] text-white font-semibold shadow hover:opacity-95"
              >
                Exportar informe peticiones
              </button>
            </div>

            {/* Informe faltantes */}
            {faltantesReport && (
              <div className="mb-4 p-3 rounded-xl bg-rose-50 border border-rose-200">
                <h4 className="font-semibold text-rose-700 mb-2">
                  Informe de faltantes ({faltantesReport.length})
                </h4>
                <ul className="text-sm space-y-1">
                  {faltantesReport.map((f, i) => (
                    <li key={i}>
                      • {f.tipo} / {f.sexo} / {f.rol} / {f.talla}
                      {f.entrenador ? " (Entrenador)" : ""}
                      {f.premama ? " (Premamá)" : ""} → Falta: {f.falta} (
                      {f.motivo})
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* FILTROS */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-4">
              <select
                className="border px-3 py-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FFC72C]"
                value={filterTipo}
                onChange={(e) => {
                  setFilterTipo(e.target.value);
                  setFilterSexo("");
                  setFilterRol("");
                  setFilterTalla("");
                }}
              >
                <option value="">Tipo (todos)</option>
                <option value="Pantalón">Pantalón</option>
                <option value="Camiseta">Camiseta</option>
                <option value="Chaqueta">Chaqueta</option>
                <option value="Americana">Americana</option>
                <option value="Chaleco">Chaleco</option>
                <option value="Calzas">Calzas</option>
                <option value="Gorra">Gorra</option>
                <option value="Bandana">Bandana</option>
                <option value="Pañuelo">Pañuelo</option>
                <option value="Cinturón">Cinturón</option>
                <option value="Delantal corto">Delantal corto</option>
                <option value="Delantal largo">Delantal largo</option>
              </select>

              <select
                className="border px-3 py-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FFC72C]"
                value={filterSexo}
                onChange={(e) => setFilterSexo(e.target.value)}
              >
                <option value="">Sexo (todos)</option>
                {filterSexoOptions.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </select>

              <select
                className="border px-3 py-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FFC72C]"
                value={filterRol}
                onChange={(e) => setFilterRol(e.target.value)}
              >
                <option value="">Rol (todos)</option>
                {filterRolOptions.map((r) => (
                  <option key={r} value={r}>
                    {r}
                  </option>
                ))}
              </select>

              <select
                className="border px-3 py-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FFC72C]"
                value={filterTalla}
                onChange={(e) => setFilterTalla(e.target.value)}
              >
                <option value="">Talla (todas)</option>
                {filterTallaOptions.map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </select>
            </div>

            {/* TABLA */}
            <table className="w-full text-sm border-separate border-spacing-y-2">
              <thead>
                <tr className="text-left bg-[#FFC72C]/20">
                  <th className="p-2">Tipo</th>
                  <th className="p-2">Sexo</th>
                  <th className="p-2">Rol</th>

                  <th
                    className="p-2 cursor-pointer select-none"
                    onClick={() =>
                      setSortTalla((prev) =>
                        prev === "asc" ? "desc" : "asc"
                      )
                    }
                    title="Clic para ordenar por talla"
                  >
                    <span className="inline-flex items-center gap-1">
                      Talla
                      <span className="text-xs">
                        {sortTalla === "asc" ? "▲" : "▼"}
                      </span>
                    </span>
                  </th>

                  <th className="p-2 text-right">Cantidad</th>
                  <th className="p-2 text-right">Acciones</th>
                </tr>
              </thead>

              <tbody>
                {filtered.map((it) => (
                  <tr
                    key={it.id}
                    className="bg-[#0B4F3A]/5 hover:bg-[#FFC72C]/10 transition"
                  >
                    <td className="p-2">
                      {it.tipo}

                      {it.tipo === "Camiseta" &&
                        it.rol === "Crew" &&
                        it.entrenador && (
                          <span className="ml-2 text-xs px-2 py-0.5 rounded-full bg-[#FFC72C]/30">
                            Entrenador
                          </span>
                        )}

                      {it.tipo === "Pantalón" &&
                        it.sexo === "Mujer" &&
                        it.premama && (
                          <span className="ml-2 text-xs px-2 py-0.5 rounded-full bg-[#FFC72C]/30">
                            Premamá
                          </span>
                        )}
                    </td>

                    <td className="p-2">{it.sexo}</td>
                    <td className="p-2">{it.rol}</td>
                    <td className="p-2">{it.talla}</td>
                    <td className="p-2 text-right">{it.cantidad}</td>

                    <td className="p-2">
                      <div className="flex justify-end gap-2">
                        <button
                          onClick={() => inc(it.id, -1)}
                          className="px-2 py-1 rounded-lg border hover:bg-slate-50"
                          title="Restar 1"
                        >
                          -1
                        </button>
                        <button
                          onClick={() => inc(it.id, +1)}
                          className="px-2 py-1 rounded-lg border hover:bg-slate-50"
                          title="Sumar 1"
                        >
                          +1
                        </button>
                        <button
                          onClick={() => editItem(it)}
                          className="px-2 py-1 rounded-lg border hover:bg-slate-50"
                          title="Editar"
                        >
                          Editar
                        </button>
                        <button
                          onClick={() => handleDelete(it.id)}
                          className="px-2 py-1 rounded-lg border hover:bg-rose-50 text-rose-600"
                          title="Borrar"
                        >
                          Borrar
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}

                {filtered.length === 0 && (
                  <tr>
                    <td colSpan="6" className="p-6 text-center text-slate-500">
                      Sin resultados…
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Botón confirmar (si lo tenías visible en tu versión anterior, déjalo donde estaba) */}
            {/* confirmRequests NO se ha cambiado salvo lo de premamá/histórico */}
          </div>
        </section>
      </main>
    </div>
  );
}
